export default "__VITE_ASSET__DgD0P5ld__"